import * as RuntimeOptions from '../RuntimeOptions';
export function pageEvents(name) {
    return RuntimeOptions.get('pageEvents')[name] || [];
}
export function appEvents() {
    return RuntimeOptions.get('appEvents');
}
